import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { PageTabs } from "@/components/ui/page-tabs";
import Edit from "./edit";
import { History } from "./history";

const ExternalUserDetails = () => {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState<"details" | "history">("details");

  const tabs = [
    { label: "Detalles", key: "details" },
    { label: "Historial", key: "history" },
  ];

  const handleTabChange = (key: string) => {
    setActiveTab(key as "details" | "history");

    if (key === "history") {
      queryClient.invalidateQueries({ queryKey: ["admin-log-list"] });
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <PageTabs
        tabs={tabs}
        activeKey={activeTab}
        onTabChange={handleTabChange}
      />

      {activeTab === "details" && <Edit />}
      {activeTab === "history" && <History />}
    </div>
  );
};

export default ExternalUserDetails;
